import {resolveBackground} from '#core/utils/color-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import EVENT_CARD_BADGE from './event-card-badge.palette-schema.yaml';

registerTileSchema(EVENT_CARD_BADGE);

export function generateEventCardBadgeRow(TILE) {
    return {
        createStackingContext: true,
        style: {
            ...resolveBackground(TILE.ACCENT_BAND),
        },
    };
}

export function generateEventCardBadge(TILE) {
    return {
        showDot: true,
        dot: {
            style: {
                backgroundColor: TILE.ACCENT_MAIN,
                borderRadius: '50%',
            },
        },
        label: {
            style: TILE.BADGE_LABEL_TEXT,
        },
    };
}
